module.exports = __webpack_public_path__ + "img/bar-chart-line.64859c83.svg";